import * as actionTypes from '../config/actionTypes';

const initialState = {
  appLoading: true,
  site: null,
  sites: [],
  sitesError: '',
  selectingSite: false,
  redirectToSite: null,
};


const stopAppLoadingReducer = (state) => {
  return {
    ...state,
    appLoading: false,
  };
};


const noSiteFoundReducer = (state) => {
  return {
    ...state,
    site: null,
  };
};


const showSitesReducer = (state, payload) => {
  return {
    ...state,
    sites: payload,
  };
};


const getSitesErrorReducer = (state, payload) => {
  return {
    ...state,
    sitesError: payload,
  };
};


const selectingSiteReducer = (state) => {
  return {
    ...state,
    selectingSite: true,
  };
};


const siteSelectedReducer = (state, payload) => {
  return {
    ...state,
    selectingSite: false,
    site: payload,
  };
};


const redirectToSiteReducer = (state, payload) => {
  return {
    ...state,
    selectingSite: false,
    redirectToSite: payload,
  };
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STOP_APP_LOADING: return stopAppLoadingReducer(state);
    case actionTypes.NO_SITE_FOUND: return noSiteFoundReducer(state);
    case actionTypes.SHOW_SITES: return showSitesReducer(state, action.payload);
    case actionTypes.GET_SITES_ERROR: return getSitesErrorReducer(state, action.payload);
    case actionTypes.SELECTING_SITE: return selectingSiteReducer(state);
    case actionTypes.SITE_SELECTED: return siteSelectedReducer(state, action.payload);
    case actionTypes.REDIRECT_TO_SITE: return redirectToSiteReducer(state, action.payload);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/common/reducers.js